import React from 'react';
import { get } from 'lodash-es';
import styled from '../../styled';
// eslint-disable-next-line import/no-duplicates
import * as Tooltip from '../tooltip';
const IconButtonWrapper = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({ size }) => (size ? `${size}rem` : '2.75rem')};
  height: ${({ size }) => (size ? `${size}rem` : '2.75rem')};
  border-radius: 4px;
  cursor: pointer;

  ${({ theme, colorType = 'basic', customColor, isDisabled }) => {
    return `
      path {
        fill: ${theme.colors[isDisabled
        ? theme.iconButton.disabled.icon
        : get(customColor, 'icon', theme.iconButton[colorType].icon)]}
      }
      &:hover {
        background-color: ${theme.colors[isDisabled
        ? theme.iconButton.disabled.bgHover
        : get(customColor, 'bgHover', theme.iconButton[colorType].bgHover)]}
        path {
          fill: ${theme.colors[isDisabled
        ? theme.iconButton.disabled.iconHover
        : get(customColor, 'iconHover', theme.iconButton[colorType].iconHover)]}
        }
      }
      &:active {
        background-color: ${theme.colors[isDisabled
        ? theme.iconButton.disabled.bgActive
        : get(customColor, 'bgActive', theme.iconButton[colorType].bgActive)]}
        path {
          fill: ${theme.colors[isDisabled
        ? theme.iconButton.disabled.iconActive
        : get(customColor, 'iconActive', theme.iconButton[colorType].iconActive)]}
        }
      }
    `;
}};
`;
const IconButton = ({ Icon, size, colorType, iconProps, tooltipProps, customColor, handleClick, isDisabled, }) => {
    return (React.createElement(Tooltip.Primary, Object.assign({}, tooltipProps),
        React.createElement(IconButtonWrapper, { colorType: colorType, customColor: customColor, size: size, onClick: handleClick, isDisabled: isDisabled },
            React.createElement(Icon, Object.assign({}, iconProps)))));
};
export default IconButton;
//# sourceMappingURL=index.js.map